module.exports = __webpack_public_path__ + "static/media/courses.32171a74.svg";